import axios from 'axios';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

const API_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:8000'
    : 'https://wb5gekn817.execute-api.eu-north-1.amazonaws.com';

export type EndSessionOutput = { message: string };

export type ImproveGeneratedCodeOutput = {
  llm_message: string;
  code: string;
  suggested_improvements: string[];
};

export type GenerateInitialCodeOutput = {
  llm_message: string;
  code: string;
  suggested_improvements: string[];
};

export type GatherUserInfoOutput = {
  llm_message: string;
  suggested_answers: string[];
  finished_info_gathering: boolean;
};

export type CreateUserOutput = {
  user_id: string;
};

export interface UserInput {
  user_id: string;
  user_input: string;
}

export interface UserIdInput {
  user_id: string;
}

export const healthCheck = <TData = AxiosResponse<unknown>>(
  options?: AxiosRequestConfig,
): Promise<TData> => {
  return axios.get(`${API_URL}`, options);
};

export const createUser = <TData = AxiosResponse<CreateUserOutput>>(
  options?: AxiosRequestConfig,
): Promise<TData> => {
  return axios.post(`${API_URL}/create_user`, undefined, options);
};

export const gatherInfo = <TData = AxiosResponse<GatherUserInfoOutput>>(
  userInput: UserInput,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  return axios.post(`${API_URL}/gather_user_info`, userInput, options);
};

export const generateCode = <TData = AxiosResponse<GenerateInitialCodeOutput>>(
  userIdInput: UserIdInput,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  return axios.post(`${API_URL}/generate_initial_code`, userIdInput, options);
};

export const improveCode = <TData = AxiosResponse<ImproveGeneratedCodeOutput>>(
  userInput: UserInput,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  return axios.post(`${API_URL}/improve_generated_code`, userInput, options);
};

export const endSession = <TData = AxiosResponse<EndSessionOutput>>(
  userIdInput: UserIdInput,
  options?: AxiosRequestConfig,
): Promise<TData> => {
  return axios.post(`${API_URL}/end_session`, userIdInput, options);
};
